<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div style="margin: 0.2rem;" ref="wrapper">
      <!-- 站点收藏 -->
      <div>
        <div class="caaa text-left" style="margin: 0.2rem 0; font-size: 0.4rem;">
          站点收藏：
        </div>
        <div class="bgfff flex flex-wrap" style="padding: 0.2rem;">
          <div class="text-left flex" style="
              width: 50%;
              font-weight: bold;
              padding: 0.2rem;
              font-size: 0.38rem;
              box-sizing: border-box;
            " v-for="(item, index) in collectNodeList" :key="index" @click="searchCollectNode(item.NodeName)">
            <div style="flex: 1;">{{ item.NodeName }}</div>
            <div style="line-height: 0.7rem;" @click.stop="collectNodeRemove(item)">
              <van-icon name="cross" />
            </div>
          </div>
        </div>
      </div>
      <!-- 搜索 -->
      <div style="margin-top: 0.7rem;">
        <div class="caaa text-left" style="margin: 0.2rem 0; font-size: 0.4rem;">
          按站点名称查询：
        </div>
        <van-search v-model="searchNode" placeholder="请输入搜索站点名称" clear-trigger="always" />
      </div>
      <!-- 过期班次 -->
      <div style="margin-top: 0.7rem;">
        <div class="caaa text-left" style="margin: 0.2rem 0; font-size: 0.4rem;">
          过期班次：
        </div>
        <van-radio-group v-model="showExpired" direction="horizontal">
        <van-radio name="0">隐藏</van-radio>
        <van-radio name="1">显示</van-radio> 
        </van-radio-group>
      </div>
      <!-- 站点折叠面板 -->
      <div style="margin-top: 0.5rem;">
        <van-collapse v-model="activeNames" @change="nodeCollapseChange">
          <van-collapse-item :name="item.GID" v-for="item in getNodeList" :key="item.NodeGID" :ref="item.NodeGID">
            <template #title>
              <div class="text-left" style="line-height: 1rem;">
                <span class="iconfont iconzuobiao"></span>
                {{ item.NodeName }}
              </div>
            </template>
            <template #value>
              <van-button type="default" size="small" style="margin-right: 0.3rem; font-size: 0.35rem;"
                @click.stop="getNodeLineClassDay(item)">途径班次</van-button>
              <van-button type="default" size="small" @click.stop="collectNode(item)"
                :disabled="getCollectNodeBtnStatus(item.NodeGID)">{{ getCollectNodeBtnName(item.NodeGID)
                }}</van-button>
            </template>
            <div>
              <div class="flex bgf5 flex-items-center" style="padding: 0.3rem 0.2rem; margin-bottom: 0.3rem;"
                v-for="(lineclassday, index) in item.lineClassDayList" :key="index">
                <!-- 时间 -->
                <div class="flex flex-items-center">
                  <span class="iconfont iconriqi"></span>
                  <span style="color: #f5a255; font-weight: bold;">{{
      formatClassTime(lineclassday.ClassTime)
    }}</span>
                </div>
                <!-- 线路名称 -->
                <div class="text-left" style="flex: 1; padding-left: 0.2rem; font-weight: bold;">
                  <!-- 站点  -->
                  <div style="font-size: 0.4rem; color: #000;">
                    {{ lineclassday.LineName }}
                  </div>
                  <!-- 车牌  -->
                  <div v-if="lineclassday.VehicleDriverList">
                    <div v-for="(Vehicle, index) in JSON.parse(
      lineclassday.VehicleDriverList
    )" :key="index" class="flex" style="margin-top: 0.1rem;">
                      <div style="
                          margin-right: 0.2rem;
                          font-size: 0.34rem;
                          color: #666;
                        ">
                        车牌：{{ Vehicle.VehicleNo }}

                        <van-icon name="success" color="#67C23A" v-if="Vehicle.IsRegulations" />
                        <van-icon name="cross" color="#F56C6C" v-if="!Vehicle.IsRegulations" />

                      </div>
                      <div style="
                          border: 1px solid red;
                          padding: 0 0.1rem;
                          font-weight: 100;
                          color: red;
                          font-size: 0.34rem;
                        " @click="onCheckVehicleDriverDetails(lineclassday, Vehicle)">
                        查看详情
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 未检 / 已检 -->
                <div style="padding: 0 0.2rem;">
                  <span style="color: red; font-weight: bold;">{{
      lineclassday.NodeUnCheckCount
    }}</span>
                  <span>&nbsp;/&nbsp; </span>
                  <span style="color: green; font-weight: bold;">{{
        lineclassday.NodeCheckCount
      }}</span>
                </div>
                <!-- 检票按钮 -->
                <div>
                  <van-button color="#ff9900" size="small" @click.stop="gotoCheck(lineclassday, item)">检票</van-button>
                </div>
              </div>
              <div v-if="!item.lineClassDayList || item.lineClassDayList.length <= 0
      ">
                该站点暂无途径班次
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "站点选择",
      searchNode: "", // 搜索站点
      activeNames: [], // 展示内容的折叠项 名称数组
      collectNodeList: [], // 收藏站点列表
      loginUser: null, // 登录用户
      nodeList: [], // 公司上车站点列表
      scrollTop: 0, // 记录离开页面时滚动条位置
      showExpired: "1", // 默认：显示过期班次
    };
  },
  computed: {
    /**
     * 获取登录用户
     */
    getLoginUser() {
      let result = this.loginUser;
      if (!result) {
        let adminInfoJson = window.localStorage.getItem("adminInfo");
        if (adminInfoJson) {
          this.loginUser = JSON.parse(adminInfoJson);
          result = this.loginUser;
        }
      }
      return result;
    },
    /**
     * 获取收藏按钮名称
     */
    getCollectNodeBtnName() {
      return (nodeGID) => {
        let result = "收藏";
        if (this.isExistCollectNode(nodeGID)) {
          return "已收藏";
        }
        return result;
      };
    },
    /**
     * 获取收藏按钮状态
     */
    getCollectNodeBtnStatus() {
      return (nodeGID) => {
        let result = false;
        if (this.isExistCollectNode(nodeGID)) {
          return true;
        }
        return result;
      };
    },
    /**
     * 获取站点列表
     */
    getNodeList() {
      return this.nodeList.filter((n) => n.NodeName.includes(this.searchNode));
    },
    /**
     * 格式化班次时间
     */
    formatClassTime() {
      return (time) => {
        return time.substr(0, 5);
      };
    },
  },
  methods: {
    // 查看车辆详情
    onCheckVehicleDriverDetails(lineclassday, data) {
      window.localStorage.setItem("lineClassDay", JSON.stringify(lineclassday));
      this.$router.push({
        path: "VehicleMapV2",
        query: {
          VehicleGIDList: data.VehicleGID,
          NodeGeocoder: lineclassday.NodeGeocoder
        },
      });
    },

    /**
     * 获取数据
     */
    async getData() {
      this.getCollectNode();
      await this.getCompanyStartNode();
    },
    /**
     * 判断站点是否存在收藏站点里
     */
    isExistCollectNode(nodeGID) {
      return this.collectNodeList.findIndex((c) => c.NodeGID == nodeGID) > -1;
    },
    /**
     * 查询收藏站点
     */
    searchCollectNode(e) {
      this.searchNode = e;
    },
    /**
     * 获取收藏站点
     */
    getCollectNode() {
      let collectNodeList = JSON.parse(
        window.localStorage.getItem("collectNodeList") || "[]"
      );
      this.collectNodeList = collectNodeList;
      return collectNodeList;
    },
    /**
     * 收藏站点
     */
    collectNode(e) {
      this.collectNodeList.push(e);
      window.localStorage.setItem(
        "collectNodeList",
        JSON.stringify(this.collectNodeList)
      );
      this.$toast.success("添加成功");
    },
    /**
     * 移除收藏站点
     */
    collectNodeRemove(e) {
      let index = this.collectNodeList.findIndex((n) => n.NodeGID == e.NodeGID);
      this.collectNodeList.splice(index, 1);
      window.localStorage.setItem(
        "collectNodeList",
        JSON.stringify(this.collectNodeList)
      );
      this.$toast.success("移除成功");
    },
    /**
     * 获取公司站点
     */
    async getCompanyStartNode(e) {
      return new Promise((resolve, reject) => {
        this.$http
          .post(this.$api.getCompanyStartNode, {})
          .then((res) => {
            // console.log("获取公司站点", res);
            resolve();
            if (res.success) {
              this.nodeList = res.data;
              // console.log(this.nodeList);
            }
          })
          .catch((res) => {
            console.error("获取公司站点错误", res);
            resolve();
          });
      });
    },
    /**
     * 获取站点途径班次
     */
    getNodeLineClassDay(item) {
      let nodeGID = item.NodeGID;
      let params = {
        NodeGID: nodeGID,
        BeginDate: this.$moment(new Date()).format("YYYY-MM-DD 00:00:00"),
        EndDate: this.$moment(new Date()).format("YYYY-MM-DD 23:59:59"),
        IsFilterLineOrganization: true
      };
      let that = this;
      this.$http
        .post(this.$api.getNodeLineClassDay, this.$qs.stringify(params))
        .then((res) => {
          console.log("获取站点途径班次", res);
          if (res.success) {
            let node = this.nodeList.find((n) => n.NodeGID == nodeGID);

            // 如果 showExpired 是 "0"，则过滤掉过期的班次；如果是 "1"，则显示所有班次
            // 过滤实时班次的最后一个上车站点时间，如果该时间小于当前时间，则认为该班次过期
            if (that.showExpired === "0") {
              const now = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
              const today = this.$moment(new Date()).format("YYYY-MM-DD");
              node.lineClassDayList = res.data.filter(day => {
                try {
                  // 拼接发车时间：当天日期 + 班次时间
                  //const classTime = new Date(`${today} ${day.ClassTime}`);
                  const classTime =  this.$moment(new Date(`${today} ${day.ClassTime}`)).format("YYYY-MM-DD HH:mm:ss");
                  // 只保留 >= 当前时间的班次
                  return classTime >= now;
                } catch (e) {
                  return true;
                }
              });
            } else {

            node.lineClassDayList = res.data;
            console.log(node);
            }
            // 展开折叠项
            this.$refs[nodeGID][0].toggle(true);
          }
        })
        .catch((res) => {
          console.error("获取站点途径班次错误", res);
        });
    },
    /**
     * 跳转检票
     */
    gotoCheck(lineclassday, node) {
      node.ClassTime = lineclassday.ClassTime.substr(0, 5);
      node.NodeGID = lineclassday.NodeGID;
      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(node)
      );
      window.localStorage.setItem("lineClassDay", JSON.stringify(lineclassday));
      window.localStorage.setItem(
        "lineClassDayCheckedCount",
        lineclassday.CheckCount - lineclassday.NodeCheckCount
      );
      // 使用name跳转页面，params参数才有效，使用path跳转则无效
      this.$router.push({
        name: "TicketCheck",
        params: {
          from: "NodeList",
        },
      });
    },
    /**
     * 站点折叠面板触发事件
     */
    nodeCollapseChange(activeNames) {
      console.log("nodeCollapseChange", activeNames);
    },
  },
  created() {
    this.getData();
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    let list = this.$refs["wrapper"];
    this.scrollTop = list.scrollTop || 0;
    next();
  },
  // 被 keep-alive 缓存的组件激活时调用。
  activated() {
    this.$refs["wrapper"].scrollTop = this.scrollTop;
  },
};
</script>

<style lang="less">
@search-padding: 0px;
</style>
